// Shared gender bucket used to color-code performer/client names across
// business service cards and mobile screens.
export type GenderBucket = 'men' | 'women'

/**
 * Normalizes a raw API gender string (`MALE`/`FEMALE`/`M`/`F`, case-insensitive)
 * into a `GenderBucket`, or `null` when the value is missing or unrecognized.
 */
export function genderBucket(raw: string | null | undefined): GenderBucket | null {
  const value = raw?.trim().toUpperCase()
  if (value === 'MALE' || value === 'M') return 'men'
  if (value === 'FEMALE' || value === 'F') return 'women'
  return null
}
